// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  runId: __t.u64().primaryKey().name("run_id"),
  identity: __t.identity(),
  tier: __t.u32(),
  seed: __t.string(),
  state: __t.string(),
  roomsClaimed: __t.u32().name("rooms_claimed"),
  lastRoomAt: __t.timestamp().name("last_room_at"),
  startedAt: __t.timestamp().name("started_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
